import { RootState } from "../../store";
import { IBillingLocation, IBillingLocationApi, IBillingLocationsListRequest } from "../../types/billingLocations";
import { ReplaceFilterField } from "../../types/filters";
import { adaptFilterItemsForBe, adaptOrderingForBe } from "./adaptFiltersToBe";

export const adaptResponseForFrontend = (billingLocations: IBillingLocationApi[]): IBillingLocation[] => {
  return billingLocations.map((apiVisit) => {
    return {
      id: apiVisit.id,
      locationId: apiVisit.location_id,
      amount: apiVisit.amount,
      depositAmount: apiVisit.amount,
      increaseComparison: apiVisit.increase_comparison,
      householdMembersCount: apiVisit.household_members_count,
      name: apiVisit.name,
      enableTime: apiVisit.enable_time,
      disableTime: apiVisit.disable_time,
      previousWaste: apiVisit.previous_waste,
      isPaid: apiVisit.is_paid,
      isActive: apiVisit.is_active,
      realAmount: Number(apiVisit.real_amount),
      currentWaste: apiVisit.current_waste,
      balance: Number(apiVisit.balance),
      wasteIncrease: Number(apiVisit.waste_increase),
    };
  });
};

const REPLACE_BE_FILTER_FIELD: ReplaceFilterField[] = [{ from: "depositAmount", to: "amount" }];

export const adaptRequestBodyForBackend = (state: RootState["billingLocations"]): IBillingLocationsListRequest => {
  const { pagination, search, ordering, filters } = state;

  return {
    fulltext: search.fulltext,
    pagination,
    ordering: adaptOrderingForBe(ordering, REPLACE_BE_FILTER_FIELD),
    filters: adaptFilterItemsForBe(filters.items, REPLACE_BE_FILTER_FIELD),
  };
};
